var map = {
	"./blues.png": 38932,
	"./browns.png": 20924,
	"./grays.png": 93935,
	"./greens.png": 22299,
	"./oranges.png": 76290,
	"./reds.png": 24663,
	"./violets.png": 80555,
	"./whites.png": 53253,
	"./yellows.png": 27160
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71140;